import { type FC } from "react";
import { Text, TextProps } from "@chakra-ui/react";

export const SupportingText: FC<TextProps> = (props) => {
  return (
    <Text color="th.gray4" textAlign="center" variant="th-body3" {...props} />
  );
};
